import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozWeight', bringozWeight);

function bringozWeight(splitService, $filter) {
  return function packageWeightFilter(weight, enableUnitDisplay, defaultValue, isShortUnitDisplayName, decimals) {
    if (_.isUndefined(weight)) {
      return defaultValue || '--'
    }
    const siteUnit = !!isShortUnitDisplayName ? splitService.getShortWeightUnit()
      : splitService.getWeightUnit();
    const calculatedWeight = decimals !== undefined 
      ? weight.toFixed(decimals) 
      : weight.toFixed(Number.isInteger(weight) ? 0 : 3);
    const weightUnit = $filter('translate')(`WEIGHT_UNIT.${siteUnit}`);
    return calculatedWeight + (enableUnitDisplay ? (' ' + weightUnit) : '');

  }
}
